<template>
  <el-drawer v-model="visible" size="100%" custom-class="sys-electronic-fence-drawer">
    <div ref="mapContainer" style="width:100%;height: 100%;"></div>
  </el-drawer>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  emits: ["update:modelValue"],
  data(){
    return {
      map: null
    }
  },
  props: {
    modelValue: Boolean,
    electronicFence: String
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    }
  },
  watch: {
    modelValue(val) {
      if (val) {
        this.clearMap();
        this.setMap();
      }
    }
  },
  methods: {
    setMap() { // 设置地图
      if (!this.$refs.mapContainer) {
         setTimeout(this.setMap, 50);
         return;
      }
      if (!this.map) {
        this.map = new AMap.Map(this.$refs.mapContainer, {
          resizeEnable: true // 允许缩放
        });
      }
      this.setElectronicFence();
    },
    setElectronicFence() { // 设置电子围栏
      if(this.electronicFence){
        let polygons = JSON.parse(this.electronicFence);
        if (polygons == null) return;
        for (let i = 0; i < polygons.length; i++) {
          this.map.add(new AMap.Polygon(polygons[i]));
        }
        this.map.setFitView()
      }
    },
    clearMap() {
      this.map && this.map.clearMap(); // 清除地图上的所有覆盖物
    }
  }
})
</script>

<style lang="scss" >
.sys-electronic-fence-drawer {
  .el-drawer__header{
    padding: 5px 10px 5px 10px;
    background: #d0d0d0;
    margin-bottom: 0px;
  }
  .el-drawer__body{
    padding: 0;
  }
}
</style>